import { AUTH_TOKEN_STORAGE_KEY } from './auth-storage';

const AUTH_LOGOUT_CHANNEL = 'paygatex-auth-logout';
const AUTH_LOGOUT_MESSAGE = 'logout';

type AuthLogoutListener = () => void;

const getBroadcastChannel = (): BroadcastChannel | null => {
  if (typeof BroadcastChannel === 'undefined') {
    return null;
  }

  return new BroadcastChannel(AUTH_LOGOUT_CHANNEL);
};

export const broadcastAuthLogout = (): void => {
  getBroadcastChannel()?.postMessage(AUTH_LOGOUT_MESSAGE);
};

export const subscribeToAuthLogout = (listener: AuthLogoutListener): (() => void) => {
  const channel = getBroadcastChannel();

  const handleChannelMessage = (event: MessageEvent<string>) => {
    if (event.data === AUTH_LOGOUT_MESSAGE) {
      listener();
    }
  };

  const handleStorageEvent = (event: StorageEvent) => {
    if (event.key !== AUTH_TOKEN_STORAGE_KEY || event.newValue != null) {
      return;
    }

    listener();
  };

  channel?.addEventListener('message', handleChannelMessage);
  window.addEventListener('storage', handleStorageEvent);

  return () => {
    channel?.removeEventListener('message', handleChannelMessage);
    channel?.close();
    window.removeEventListener('storage', handleStorageEvent);
  };
};
